import { render, staticRenderFns } from "./login_view.vue?vue&type=template&id=85825b10&scoped=true&"
import script from "./login_view.vue?vue&type=script&lang=js&"
export * from "./login_view.vue?vue&type=script&lang=js&"
import style0 from "./login_view.vue?vue&type=style&index=0&id=85825b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85825b10",
  null
  
)

export default component.exports